@if(isLoading) {
<div class="loading-overlay">
  <div class="loading-spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>
} @if(isUsuarioLogado) {
<div class="page-title">
  <h1>Meu perfil</h1>

  <div class="trailing">
    @if(formData.status.toUpperCase() === 'ATIVO') {
    <span class="status-pill status-active">Ativo</span>
    } @else if (formData.status.toUpperCase() === 'BLOQUEADO') {
    <span class="status-pill status-inactive">Inativo</span>
    } @else if (formData.status.toUpperCase() === 'PENDENTE') {
    <span class="status-pill status-pendente">Pendente</span>
    } @else {
    <span class="status-pill status-inactive">Inativo</span>
    }
  </div>
</div>
} @else if(modoEdicaoAtivo) {
<div class="page-title">
  <h1>Visualizar usuário</h1>

  <div class="trailing">
    @if(formData.status.toUpperCase() === 'ATIVO') {
    <span class="status-pill status-active">Ativo</span>
    } @else if (formData.status.toUpperCase() === 'BLOQUEADO') {
    <span class="status-pill status-inactive">Inativo</span>
    } @else if (formData.status.toUpperCase() === 'PENDENTE') {
    <span class="status-pill status-pendente">Pendente</span>
    } @else {
    <span class="status-pill status-inactive">Inativo</span>
    }
  </div>
</div>
} @else {
<div class="page-title">
  <h1>Cadastrar usuário</h1>
</div>
}

<section>
  <p class="section-title">VÍNCULO COM EMPRESA</p>

  <mat-form-field
    appearance="outline"
    class="full-width"
    [class.error]="touchedEmpresa && !empresaSelecionada"
  >
    <input
      matInput
      type="text"
      [(ngModel)]="empresaDummyModel"
      name="empresaSelecionada"
      [value]="empresaSelecionada?.nomeFantasia || ''"
      placeholder="Vincular empresa*"
      readonly
      [disabled]="isSaude()||usuarioEstaInativo() || empresaSelecionada"
      (click)="!empresaSelecionada && abrirModalEmpresas()"
      [ngStyle]="!empresaSelecionada ? { cursor: 'pointer' } : {}"
    />
  </mat-form-field>

  <p
    *ngIf="touchedEmpresa && !empresaSelecionada"
    style="
      color: #ba1a1a;
      font-size: 12px;
      margin-top: -10px;
      margin-bottom: 20px;
    "
  >
    Empresa obrigatória
  </p>

  @if(empresaSelecionada) {
  <div class="endereco-empresa-selecionada-card">
    <p>{{ empresaSelecionada?.nomeFantasia }}</p>

    @if (!isUsuarioLogado) { @if(!isSaude()||usuarioEstaInativo()) {
    <img
      src="../../../../assets/svg/icons/trash.svg"
      (click)="abrirDesvincularEmpresa()"
      style="cursor: pointer"
    />
    }}
  </div>
  }

  <mat-form-field appearance="outline" class="full-width">
    <input
      matInput
      type="text"
      [value]="enderecoSelecionado?.labelEndereco || ''"
      placeholder="Vincular endereço*"
      readonly
      [disabled]="isSaude() || isSaude()||usuarioEstaInativo() || !empresaSelecionada || enderecoSelecionado"
      (click)="empresaSelecionada && !enderecoSelecionado && abrirModalEnderecos()"
      [ngStyle]="empresaSelecionada && !enderecoSelecionado ? { cursor: 'pointer' } : {}"
    />
  </mat-form-field>

  <p
    class="erro"
    *ngIf="touchedEndereco && empresaSelecionada && !enderecoSelecionado"
    style="
      color: #ba1a1a;
      font-size: 12px;
      margin-top: -10px;
      margin-bottom: 20px;
    "
  >
    Endereço obrigatório
  </p>

  <div class="endereco-empresa-selecionada-card" *ngIf="enderecoSelecionado">
    <p>{{ enderecoSelecionado.labelEndereco }}</p>

    @if (!isUsuarioLogado) { @if(!isSaude()||usuarioEstaInativo()) {
    <img
      src="../../../../assets/svg/icons/trash.svg"
      (click)="abrirDesvincularEndereco()"
      style="cursor: pointer"
    />
    } }
  </div>
</section>

<div class="spacer" style="height: 2em"></div>

<section>
  <p class="section-title">DADOS GERAIS</p>

  <mat-grid-list cols="4" rowHeight="100px" gutterSize="1em">
    <!-- Linha 1 - Selects -->
    <mat-grid-tile colspan="2">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Naturalidade</mat-label>
        <mat-select
          [(ngModel)]="formData.naturalidade"
          name="naturalidade"
          (selectionChange)="handleNaturalidadeChange(formData.naturalidade)"
          (ngModelChange)="updateForm('naturalidade', $event)"
          required
          [disabled]="isSaude()||usuarioEstaInativo() || isUsuarioLogado"
        >
          <mat-option
            *ngFor="let option of naturalidadeOptions"
            [value]="option.value"
          >
            {{option.viewValue}}
          </mat-option>
        </mat-select>
        <mat-error>Campo obrigatório</mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Documento de Identificação</mat-label>
        <mat-select
          [(ngModel)]="formData.tipoDocumento"
          name="tipoDocumento"
          [disabled]="isSaude()||usuarioEstaInativo() || !formData.naturalidade || formData.naturalidade === 'Brasileiro'"
          required
          (ngModelChange)="updateForm('tipoDocumento', $event)"
          (selectionChange)="handleDocTipoChange(formData.tipoDocumento)"
        >
          <mat-option
            *ngFor="let option of filteredTipoDocumentoOptions"
            [value]="option.value"
          >
            {{option.viewValue}}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="usuarioForm.get('tipoDocumento')?.hasError('invalid')"
        >
          Brasileiros devem usar CPF
        </mat-error>
        <mat-error
          *ngIf="usuarioForm.get('tipoDocumento')?.hasError('required')"
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <!-- Linha 2 - Inputs Texto -->
    <mat-grid-tile colspan="2">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Número do Documento</mat-label>
        <input
          matInput
          [(ngModel)]="formData.numeroDocumento"
          (ngModelChange)="updateForm('numeroDocumento', $event)"
          name="numDoc"
          placeholder="Número do documento*"
          required
          [mask]="useCPF() ? '000.000.000-00' : null "
          [disabled]="isSaude()||usuarioEstaInativo() || isUsuarioLogado"
        />
        <mat-error>Campo obrigatório</mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nome Completo</mat-label>
        <input
          matInput
          [(ngModel)]="formData.nomeCompleto"
          (ngModelChange)="updateForm('nomeCompleto', $event)"
          name="nomeCompleto"
          placeholder="Nome completo*"
          required
          [disabled]="isSaude()||usuarioEstaInativo() || isUsuarioLogado"
        />
        <mat-error>Campo obrigatório</mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <!-- Linha 3 - Data e Email -->
    <mat-grid-tile colspan="2">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Data de Nascimento</mat-label>
        <input
          matInput
          [(ngModel)]="formData.dataNascimento"
          (ngModelChange)="updateForm('dataNascimento', $event)"
          name="dataNascimento"
          type="date"
          required
          [disabled]="isSaude()||usuarioEstaInativo() || isUsuarioLogado"
        />
        <mat-error>Campo obrigatório</mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input
          matInput
          [(ngModel)]="formData.email"
          (ngModelChange)="updateForm('email', $event)"
          name="email"
          type="email"
          placeholder="Email*"
          required
          [disabled]="isSaude()||usuarioEstaInativo() || isUsuarioLogado || usuarioEstaPendente()"
        />
        <mat-error>Informe um email válido</mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <!-- Linha 4 - Telefone e Select -->
    <mat-grid-tile colspan="2">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Telefone Celular</mat-label>
        <input
          matInput
          [(ngModel)]="formData.telefoneCelular"
          (ngModelChange)="updateForm('telefoneCelular', $event)"
          name="telefoneCelular"
          placeholder="Telefone celular*"
          required
          mask="(00) 00000-0000"
          [disabled]="usuarioEstaInativo()"
        />
        <mat-error>Campo obrigatório</mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Departamento Regional</mat-label>
        <mat-select
          [(ngModel)]="formData.departamentoRegional"
          (ngModelChange)="updateForm('departamentoRegional', $event)"
          name="departamentoRegional"
          required
          [disabled]="isSaude()||usuarioEstaInativo() || isUsuarioLogado"
        >
          <mat-option
            *ngFor="let option of departamentoRegionalOptions"
            [value]="option.value"
          >
            {{option.viewValue}}
          </mat-option>
        </mat-select>
        <mat-error>Campo obrigatório</mat-error>
      </mat-form-field>
    </mat-grid-tile>

    <!-- Linha 5 - Select Perfil -->
    <mat-grid-tile colspan="2">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Perfil de Acesso</mat-label>
        <mat-select
          [(ngModel)]="formData.perfilDeAcesso"
          (ngModelChange)="updateForm('perfilDeAcesso', $event)"
          name="perfilDeAcesso"
          required
          [disabled]="isSaude()||usuarioEstaInativo() || isUsuarioLogado"
        >
          <mat-option
            *ngFor="let option of perfilAcessoOptions"
            [value]="option.value"
          >
            {{option.viewValue}}
          </mat-option>
        </mat-select>
        <mat-error>Campo obrigatório</mat-error>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <div class="actions">
    <!-- Usuário Inativo -->
    @if (!isUsuarioLogado&&usuarioEstaInativo()) {
    <button matButton="filled" type="button" (click)="ativarUsuario()">
      Ativar
    </button>
    }

    <!-- Usuário Ativo -->
    @else {

    <!-- Modo edição -->
    @if (modoEdicaoAtivo && !isUsuarioLogado && podeInativar() ) {
    <button matButton="outlined" type="button" (click)="inativarUsuario()">
      Inativar
    </button>
    }

    <button matButton="outlined" type="button" (click)="onCancel()">
      Sair sem salvar
    </button>

    <button
      matButton="filled"
      color="primary"
      type="button"
      (click)="onSubmit()"
    >
      Salvar
    </button>
    }
  </div>
</section>
